/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Token/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Token({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ReconnectAction/Content/Reconnect/ApiToken/Token",
  onChange,
  isInvalid
  
}) {
let connectionTokenValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'token',
})
let connectionTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'connection',
path: 'token',
validate: fromValidate.textAtLeastOneChar,
required: true,
})
let connectionTokenChangeData = fromData.useDataChange({ viewPath,
context: 'connection',
path: 'token',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 type="text"
 autoFocus={true}
 label="API token"
 data="connection.token"
 onChange={connectionTokenChangeData}
 value={connectionTokenValueData}
 required={true}
 validate="/Simple/Data/validate.js textAtLeastOneChar"
 invalid={!connectionTokenIsValidData}
/>
{children}
</React.Fragment>)
}